module.exports = __webpack_public_path__ + "static/media/poste_2.f9e1e8eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_2.jpg
// module id = 248
// module chunks = 0